import { FavoriteItemsSuccessResponse } from '@libs/common-next';

import { cweaClient } from '../clients/api-proxy-browser-client';
import { CWEA_ENDPOINTS } from '../constants';

export async function getFavorites({ storeId = null }: { storeId?: string | null }) {
    const url = CWEA_ENDPOINTS.favorites.get(storeId);

    return await cweaClient.get<FavoriteItemsSuccessResponse>(url);
}

export async function addFavorite({ sku }: { sku: string }) {
    const url = CWEA_ENDPOINTS.favorites.post({ sku });

    return await cweaClient.post<FavoriteItemsSuccessResponse>(url);
}

export async function removeFavorite({ sku }: { sku: string }) {
    const url = CWEA_ENDPOINTS.favorites.delete({ sku });

    return await cweaClient.delete<FavoriteItemsSuccessResponse>(url);
}
